<div class="map-page-container">
  <div #mapContainer class="map"></div>

  <div #popup class="ol-popup">
    <a href="#" class="ol-popup-closer" (click)="closePopup($event)">×</a>
    <div #popupContent></div>
  </div>
</div>

@if (markers.length > 0) {
<div class="map-actions">
  <dx-button stylingMode="contained"
             text="Apri in Google Maps"
             icon="globe"
             (onClick)="openGoogleMaps()">
  </dx-button>
  <dx-button stylingMode="contained"
             text="Street View"
             icon="map"
             (onClick)="openStreetView()">
  </dx-button>
</div>
}
